import { observer }        from 'mobx-react-lite';
import { HistoryOutlined } from '@ant-design/icons';
import HeaderButton        from '@/TokamapEditor/ux/Header/HeaderButton';
import leftSidebarStore    from '@/TokamapEditor/stores/leftSidebarStore';
import currentEditorStore  from '@/TokamapEditor/stores/currentEditorStore';

const HistoryButton = observer(() => {
	if (!currentEditorStore.isCenterDefined) return null;

	const active = leftSidebarStore.opened && leftSidebarStore.options.reference === 'history';

	return (
		<HeaderButton
			icon={<HistoryOutlined />}
			active={active}
			onClick={() => {
				if (leftSidebarStore.options.reference === 'history') return leftSidebarStore.close();
				return leftSidebarStore.openHistory();
			}}
		>
			Historique
		</HeaderButton>
	);
});

export default HistoryButton;
